import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ActionReducerMap, StoreModule } from '@ngrx/store';

import { UserAlertsContainer } from '@user-alerts/user-alerts.container';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { CanActivateViaAuthGuard } from '@user-history/guard/session.guard';
import { UserAlertsFacade } from '@user-alerts/store/user-alerts.facade';
import { UserAlertsRoutingModule } from '@user-alerts/user-alerts-routing.module';
import { AlertCardComponent } from '@user-alerts/components/alert-card/alert-card.component';
import { WidgetsModule } from '@shared/widgets/widgets.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { UserAlertsState, userAlertsFeatureName } from '@user-alerts/store/state/user-alerts.state';
import { userAlertsRootReducer } from '@user-alerts/store/reducers';
import { FormValidationService } from '@reservation/services/form-validation.service';
import { BaseSearchBarFacade } from '@shared/base-search-bar/base-search-bar-facade';
import { ActiveAlertsPipe } from '@user-alerts/pipes/active-alerts.pipe';
import {
  AlertCreatedEditedModalComponent
} from '@user-alerts/components/alert-notification/alert-created-edited-modal.component';
import { UserAlertsDesktopComponent } from '@user-alerts/components/user-alerts-desktop/user-alerts-desktop.component';
import { ConfirmDeleteAlertComponent } from '@user-alerts/components/confirm-delete-alert/confirm-delete-alert.component';
import { CreateAlertMobileComponent } from '@user-alerts/components/create-alert-mobile/create-alert-mobile.component';
import { SearchBarModule } from '@search-bar/search-bar.module';
import { FormCurrencyInputModule } from '@forms/form-currency-input/form-currency-input.module';
import { BtnLoaderModule } from '@ux/components/btn-loader/btn-loader.module';
import { HomeItemDetailFacade } from '@home-item-detail/home-item-detail.facade';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { FixedSurfaceModule } from '@ux/components/fixed-surface/fixed-surface.module';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';
import { HeaderDsComponent } from '@design-system/components/templates/header/header.component';
import { CheckboxDsComponent } from '@design-system/components/organisms/checkbox/checkbox.component';

export const USER_ALERTS_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<UserAlertsState>
>('Feature User Alerts Reducers');

@NgModule({
  declarations: [
    UserAlertsContainer,
    AlertCardComponent,
    ActiveAlertsPipe,
    AlertCreatedEditedModalComponent,
    UserAlertsDesktopComponent,
    ConfirmDeleteAlertComponent,
    CreateAlertMobileComponent
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(userAlertsFeatureName, USER_ALERTS_REDUCER_TOKEN),
    TranslocoModule,
    GlobalPipesModule,
    UserAlertsRoutingModule,
    WidgetsModule,
    SwipeUpModule,
    ModalModule,
    SearchBarModule,
    FormCurrencyInputModule,
    BtnLoaderModule,
    ButtonDsComponent,
    FixedSurfaceModule,
    IconDsComponent,
    TypographyDsComponent,
    DividerDsComponent,
    HeaderDsComponent,
    CheckboxDsComponent,
  ],
  exports: [
    UserAlertsDesktopComponent,
    AlertCreatedEditedModalComponent
  ],
  providers: [
    UserAlertsFacade,
    ActiveAlertsPipe,
    CanActivateViaAuthGuard,
    FormValidationService,
    BaseSearchBarFacade,
    HomeItemDetailFacade,
    {
      provide: USER_ALERTS_REDUCER_TOKEN,
      useValue: userAlertsRootReducer
    },
    DatePipe
  ],
})
export class UserAlertsModule {}
